module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/ReserveButton/images/economics-active-normal-50.e892a0de.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/ReserveButton/images/economics-active-normal-50.png
// module id = 3430
// module chunks = 11